import { dateFormat, payment_method, paymentConditions } from '../../../utils/constants/misc'

export const getSettingsTabs = () => {
  return [
    { tabName: 'Généraux', tabIndex: '1' },
    { tabName: 'Emails sortants', tabIndex: '2' },
    { tabName: 'Emails entrants', tabIndex: '3' }
  ]
}
export const getSettingsFields = (user) => {
  const isSuperAdmin = user?.is_superAdmin

  return [
    [
      {
        tab: '1',
        name: 'label_facture',
        label: 'Factures',
        type: 'label'
      }
    ],
    [
      {
        tab: '1',
        name: 'invoice_number',
        label: 'Compteur factures',
        type: 'text',
        required: true,
        fullWidth: true,
        defaultValue: 1,
        validation: [
          {
            rule: 'req',
            error: 'Compteur factures obligatoire'
          },
          {
            rule: 'numbers',
            error: 'Compteur factures doit contenir uniquement des chiffres'
          }
        ]
      }
    ],
    [
      {
        tab: '1',
        name: 'invoice_number_prefix',
        label: 'Prefix fixe',
        type: 'text',
        required: false,
        fullWidth: true
      }
    ],
    [
      {
        tab: '1',
        name: 'invoice_number_countPrefix',
        label: 'Prefix daté',
        type: 'select',
        required: false,
        fullWidth: true,
        options: {
          type: 'data',
          returnField: 'name',
          returnFields: ['name'],
          value: 'name',
          data: dateFormat
        }
      }
    ],
    [
      {
        tab: '1',
        name: 'payment_conditions',
        label: 'Conditions de paiement Particuliers',
        type: 'select',
        required: true,
        fullWidth: true,
        options: {
          type: 'data',
          returnField: 'name',
          returnFields: ['name'],
          value: 'name',
          data: paymentConditions
        },
        validation: [
          {
            rule: 'req',
            error: 'Conditions de paiement Particuliers obligatoires'
          }
        ]
      }
    ],
    [
      {
        tab: '1',
        name: 'payment_methods',
        label: 'Métodes de paiement Particuliers',
        type: 'multiselect',
        required: true,
        fullWidth: true,
        options: {
          type: 'data',
          returnField: 'label',
          returnFields: ['label'],
          value: 'label',
          data: payment_method
        },
        validation: [
          {
            rule: 'req',
            error: 'Métodes de paiement Particuliers obligatoires'
          }
        ]
      }
    ],
    [
      {
        tab: '1',
        name: 'payment_conditions_pro',
        label: 'Conditions de paiement Pro',
        type: 'select',
        required: true,
        fullWidth: true,
        options: {
          type: 'data',
          returnField: 'name',
          returnFields: ['name'],
          value: 'name',
          data: paymentConditions
        },
        validation: [
          {
            rule: 'req',
            error: 'Conditions de paiement Pro obligatoires'
          }
        ]
      }
    ],
    [
      {
        tab: '1',
        name: 'payment_methods_pro',
        label: 'Métodes de paiement Pro',
        type: 'multiselect',
        required: true,
        fullWidth: true,
        options: {
          type: 'data',
          returnField: 'label',
          returnFields: ['label'],
          value: 'label',
          data: payment_method
        },
        validation: [
          {
            rule: 'req',
            error: 'Métodes de paiement Pro obligatoires'
          }
        ]
      }
    ],
    [
      {
        tab: '1',
        name: 'label_avoir',
        label: 'Avoirs',
        type: 'label'
      }
    ],
    [
      {
        tab: '1',
        name: 'creditNote_number',
        label: 'Compteur avoirs',
        type: 'text',
        required: true,
        fullWidth: true,
        validation: [
          {
            rule: 'req',
            error: 'Compteur avoirs obligatoire'
          },
          {
            rule: 'numbers',
            error: 'Compteur avoirs doit contenir uniquement des chiffres'
          }
        ]
      }
    ],
    [
      {
        tab: '1',
        name: 'creditNote_number_prefix',
        label: 'Prefix fixe',
        type: 'text',
        required: false,
        fullWidth: true
      }
    ],
    [
      {
        tab: '1',
        name: 'creditNote_number_countPrefix',
        label: 'Prefix daté',
        type: 'select',
        required: false,
        fullWidth: true,
        options: {
          type: 'data',
          returnField: 'name',
          returnFields: ['name'],
          value: 'name',
          data: dateFormat
        }
      }
    ],
    [
      {
        tab: '1',
        name: 'creditNote_methods',
        label: 'Métodes de remboursement Particuliers',
        type: 'multiselect',
        required: true,
        fullWidth: true,
        options: {
          type: 'data',
          returnField: 'label',
          returnFields: ['label'],
          value: 'label',
          data: payment_method
        },
        validation: [
          {
            rule: 'req',
            error: 'Métodes de remboursement Particuliers obligatoires'
          }
        ]
      }
    ],
    [
      {
        tab: '1',
        name: 'creditNote_methods_pro',
        label: 'Métodes de remboursement Pro',
        type: 'multiselect',
        required: true,
        fullWidth: true,
        options: {
          type: 'data',
          returnField: 'label',
          returnFields: ['label'],
          value: 'label',
          data: payment_method
        },
        validation: [
          {
            rule: 'req',
            error: 'Métodes de remboursement Pro obligatoires'
          }
        ]
      }
    ],

    [
      {
        tab: '1',
        name: 'label_devis',
        label: 'Devis',
        type: 'label'
      }
    ],
    [
      {
        tab: '1',
        name: 'quote_number',
        label: 'Compteur devis',
        type: 'text',
        required: true,
        fullWidth: true,
        validation: [
          {
            rule: 'req',
            error: 'Compteur devis obligatoire'
          },
          {
            rule: 'numbers',
            error: 'Compteur devis doit contenir uniquement des chiffres'
          }
        ]
      }
    ],
    [
      {
        tab: '1',
        name: 'quote_number_prefix',
        label: 'Prefix fixe',
        type: 'text',
        required: false,
        fullWidth: true
      }
    ],
    [
      {
        tab: '1',
        name: 'quote_number_countPrefix',
        label: 'Prefix daté',
        type: 'select',
        required: false,
        fullWidth: true,
        options: {
          type: 'data',
          returnField: 'name',
          returnFields: ['name'],
          value: 'name',
          data: dateFormat
        }
      }
    ],
    [
      {
        tab: '1',
        name: 'quote_validity',
        label: 'Durée de validité devis (en jours)',
        type: 'text',
        required: true,
        fullWidth: true,
        validation: [
          {
            rule: 'req',
            error: 'Durée de validité devis obligatoire'
          },
          {
            rule: 'numbers',
            error: 'Durée de validité devis doit contenir uniquement des chiffres'
          }
        ]
      }
    ],
    [
      {
        tab: '1',
        name: 'label_devis',
        label: 'Interventions',
        type: 'label'
      }
    ],
    [
      {
        tab: '1',
        name: 'intervention_number',
        label: 'Compteur interventions',
        type: 'text',
        required: true,
        fullWidth: true,
        validation: [
          {
            rule: 'req',
            error: 'Compteur interventions obligatoire'
          },
          {
            rule: 'numbers',
            error: 'Compteur interventions doit contenir uniquement des chiffres'
          }
        ]
      }
    ],
    [
      {
        tab: '1',
        name: 'intervention_number_prefix',
        label: 'Prefix fixe',
        type: 'text',
        required: false,
        fullWidth: true
      }
    ],
    [
      {
        tab: '1',
        name: 'intervention_number_countPrefix',
        label: 'Prefix daté',
        type: 'select',
        required: false,
        fullWidth: true,
        options: {
          type: 'data',
          returnField: 'name',
          returnFields: ['name'],
          value: 'name',
          data: dateFormat
        }
      }
    ],
    [
      {
        tab: '1',
        name: 'label_contracts',
        label: 'Contrats',
        type: 'label',
        isDisplay: () => isSuperAdmin
      }
    ],
    [
      {
        tab: '1',
        name: 'contract_number',
        label: 'Compteur contrats',
        type: 'text',
        required: true,
        fullWidth: true,
        isDisplay: () => isSuperAdmin,
        validation: [
          {
            rule: 'req',
            error: 'Compteur contrats obligatoire'
          },
          {
            rule: 'numbers',
            error: 'Compteur contrats doit contenir uniquement des chiffres'
          }
        ]
      }
    ],
    [
      {
        tab: '1',
        name: 'contract_number_prefix',
        label: 'Prefix fixe',
        type: 'text',
        isDisplay: () => isSuperAdmin,
        required: false,
        fullWidth: true
      }
    ],
    [
      {
        tab: '1',
        name: 'contract_number_countPrefix',
        label: 'Prefix daté',
        type: 'select',
        isDisplay: () => isSuperAdmin,
        required: false,
        fullWidth: true,
        options: {
          type: 'data',
          returnField: 'name',
          returnFields: ['name'],
          value: 'name',
          data: dateFormat
        }
      }
    ],
    [
      {
        tab: '2',
        name: 'smtp_host',
        label: 'Serveur SMTP',
        type: 'text',
        required: true,
        fullWidth: true,
        validation: [
          {
            rule: 'req',
            error: 'Serveur SMTP obligatoire'
          }
        ]
      }
    ],
    [
      {
        tab: '2',
        name: 'smtp_port',
        label: 'Port SMTP',
        type: 'text',
        required: true,
        fullWidth: true,
        validation: [
          {
            rule: 'req',
            error: 'Port SMTP obligatoire'
          },
          {
            rule: 'numbers',
            error: 'Port SMTP doit contenir uniquement des chiffres'
          }
        ]
      }
    ],
    [
      {
        tab: '2',
        name: 'smtp_secure',
        label: 'SSL',
        type: 'checkbox',
        fullWidth: true
      }
    ],
    [
      {
        tab: '2',
        name: 'smtp_user',
        label: 'Utilisateur',
        type: 'text',
        required: true,
        fullWidth: true,
        validation: [
          {
            rule: 'req',
            error: 'Utilisateur obligatoire'
          },
          {
            rule: 'email',
            error: 'Utilisateur doit être une adresse email'
          }
        ]
      }
    ],
    [
      {
        tab: '2',
        name: 'smtp_password',
        label: 'Mot de passe',
        type: 'password',
        required: true,
        fullWidth: true,
        validation: [
          {
            rule: 'req',
            error: 'Mot de passe obligatoire'
          }
        ]
      }
    ],
    [
      {
        tab: '3',
        name: 'is_inbound',
        label: 'Activer email entrant',
        type: 'checkbox',
        fullWidth: true
      }
    ],
    [
      {
        tab: '3',
        name: 'imap_host',
        label: 'Serveur IMAP',
        type: 'text',
        isDisplay: (data) => data.is_inbound,
        required: true,
        fullWidth: true,
        validation: [
          {
            rule: 'req',
            error: 'Serveur IMAP obligatoire'
          }
        ]
      }
    ],
    [
      {
        tab: '3',
        name: 'imap_port',
        label: 'Port IMAP',
        type: 'text',
        isDisplay: (data) => data.is_inbound,
        required: true,
        fullWidth: true,
        validation: [
          {
            rule: 'req',
            error: 'Port IMAP obligatoire'
          },
          {
            rule: 'numbers',
            error: 'Port SMTP doit contenir uniquement des chiffres'
          }
        ]
      }
    ],
    [
      {
        tab: '3',
        isDisplay: (data) => data.is_inbound,
        name: 'imap_secure',
        label: 'SSL',
        type: 'checkbox',
        fullWidth: true
      }
    ],
    [
      {
        tab: '3',
        isDisplay: (data) => data.is_inbound,
        name: 'imap_user',
        label: 'Utilisateur',
        type: 'text',
        required: true,
        fullWidth: true,
        validation: [
          {
            rule: 'req',
            error: 'Utilisateur obligatoire'
          },
          {
            rule: 'email',
            error: 'Utilisateur doit être une adresse email'
          },
          {
            rule: 'unique',
            object: 'setting/checkImap',
            condition: (data) => ({ imap_user: data.imap_user }),
            error: 'Email déjà utilisé',
            except: (res, data) => {
              return data.id === undefined || data.id !== res.data.id
            }
          }
        ]
      }
    ],
    [
      {
        tab: '3',
        isDisplay: (data) => data.is_inbound,
        name: 'imap_password',
        label: 'Mot de passe',
        type: 'password',
        required: true,
        fullWidth: true,
        validation: [
          {
            rule: 'req',
            error: 'Mot de passe obligatoire'
          }
        ]
      }
    ]
  ]
}
